import { useQuery } from "@apollo/client";
import { SITE_MARKET_VALUE } from "../sites.queries";

interface SiteMarketValueResult {
  ok: boolean;
  error?: string;
  marketValue: number;
  totalProducts: number;
  totalQuantity: number;
}

interface SiteMarketValueData {
  siteMarketValue: SiteMarketValueResult;
}

interface SiteMarketValueVariables {
  id: number;
}

export const useSiteMarketValue = (id: number) => {
  return useQuery<SiteMarketValueData, SiteMarketValueVariables>(
    SITE_MARKET_VALUE,
    {
      variables: { id },
    }
  );
};
